import { render } from "./ProviderPaidWarning.vue?vue&type=template&id=27ec0670&scoped=true"
import script from "./ProviderPaidWarning.vue?vue&type=script&lang=js"
export * from "./ProviderPaidWarning.vue?vue&type=script&lang=js"

import "./ProviderPaidWarning.vue?vue&type=style&index=0&id=27ec0670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ec0670"]])

export default __exports__